const getFileRendererSize = () => {
  const element = document.getElementById('renderer-id');
  const height = element && element.clientHeight;

  return {
    width: '100%',
    height: `${height}px`,
  };
};

export default getFileRendererSize;
